<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import type { CartOrderType } from "@shared/types/Cart";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import {
    CartOrderEntity,
    DistributorEntity,
    CartOrderBackupInstructionsEntity,
  } from "@shared/services/event_tracking/entities";
  import { StockLevels } from "@retailer/svelte/CartWidget/v2/Services/CartItemRequestService";

  export let show: boolean;
  export let order: CartOrderType;
  export let saveNote: () => void;

  const dispatch = createEventDispatcher();
  const { trackClick } = EventTracking;

  const close = () => {
    show = false;
    order.retailer_notes = originalOrderNote;
    order.backup_notes = originalBackupNote;
    dispatch("close");
  };

  const submit = async () => {
    submitting = true;
    await saveNote();
    submitting = false;

    const entities: (CartOrderEntity | DistributorEntity | CartOrderBackupInstructionsEntity)[] = [
      new CartOrderEntity({ distributorId: order.distributor.id, orderId: order.id }),
      new DistributorEntity({ id: order.distributor.id }),
    ];
    if (order.backup_notes?.length > 0 && !originalBackupNote) {
      const productStockStatuses = order.products.map(p => {
        return {
          product_id: p.id,
          stock_status: p.stock_status || StockLevels.temporarilyUnavailable,
        };
      });
      entities.push(new CartOrderBackupInstructionsEntity({ productStockStatuses }));
    }
    trackClick("cart_order_backup_notes_modal_save", entities);
  };

  let originalOrderNote = order.retailer_notes;
  let originalBackupNote = order.backup_notes;
  let label: string =
    order.retailer_notes?.length || order.backup_notes?.length
      ? "Edit note or backup"
      : "Add a note or backup";
  let submitting = false;
</script>

<FizzStyles>
  <Modal bind:show fizzModal={true} size="medium" closeOnBackgroundClick={false}>
    <header class="fizz-modal-header">
      <h4 class="fizz-heading-4">{label}</h4>
      <div class="fizz-modal-toggle fizz-modal-close" data-testid="action-close" on:click={close}>
        <Icon type="X" extraClassNames="fizz-text-brand cursor-pointer" height="16" width="16" />
      </div>
    </header>
    <section class="fizz-modal-main fizz-text-medium fizz-flow-16" data-grid-area="main">
      <div>
        <div class="fizz-label fizz-stack-4">Order note</div>
        <textarea
          placeholder="ex. Please send a keg tap"
          data-testid="order-notes-container"
          class="fizz-input-text fizz-full-width"
          bind:value={order.retailer_notes}
        />
      </div>
      <div>
        <div class="fizz-label fizz-stack-2">Backup instructions</div>
        <div class="fizz-stack-4">Replace items in case any are out of stock</div>
        <textarea
          placeholder="ex. Replace with different size"
          data-testid="backup-notes-container"
          class="fizz-input-text fizz-full-width"
          bind:value={order.backup_notes}
        />
      </div>
    </section>
    <footer class="fizz-modal-footer fizz-flex-row fizz-justify-end">
      <button
        class="fizz-button fizz-modal-toggle fizz-inline-8"
        data-testid="action-cancel"
        disabled={submitting}
        on:click={close}
      >
        Cancel
      </button>
      <button
        class="fizz-button-secondary"
        data-testid="action-save"
        disabled={submitting}
        on:click={submit}
      >
        Save
      </button>
    </footer>
  </Modal>
</FizzStyles>
